import React from 'react';
import { Card, CardBody, Badge } from 'reactstrap';

function fmtUptime(sec) {
  if (!sec) return '—';
  const d = Math.floor(sec / 86400);
  const h = Math.floor((sec % 86400) / 3600);
  const m = Math.floor((sec % 3600) / 60);
  if (d) return `${d}d ${h}h ${m}m`;
  if (h) return `${h}h ${m}m`;
  return `${m}m`;
}

export default function SystemHeader({ system }) {
  if (!system) return null;
  const envColor = system.env === 'production' ? 'danger' : system.env === 'staging' ? 'warning' : 'secondary';
  return (
    <Card className='mb-3' style={{ borderLeft: `4px solid ${envColor === 'danger' ? '#dc3545' : '#6c757d'}` }}>
      <CardBody style={{ padding: '14px 20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', fontSize: 15 }}>
          <strong style={{ fontSize: 20 }}>Admin Ops</strong>
          <Badge color={envColor}>{system.env}</Badge>
          <span>Ruby <code>{system.rubyVersion}</code></span>
          <span>Rails <code>{system.railsVersion}</code></span>
          <span>Uptime <strong>{fmtUptime(system.uptimeSec)}</strong></span>
          {system.gitSha && <span>SHA <code>{system.gitSha.slice(0, 8)}</code></span>}
          <span style={{ marginLeft: 'auto', color: '#888' }}>
            Server: {system.serverTime ? new Date(system.serverTime).toLocaleTimeString() : '—'}
          </span>
        </div>
      </CardBody>
    </Card>
  );
}
